var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2486 5L16.5486 3.825C16.3503 3.77531 16.1467 3.75012 15.9423 3.75H10.9198C10.4555 3.75002 10.0003 3.87937 9.6053 4.12355C9.21032 4.36774 8.89116 4.71711 8.68359 5.1325L4.30859 13.8825C4.11813 14.2636 4.02824 14.6871 4.04747 15.1128C4.06669 15.5384 4.19439 15.9521 4.41843 16.3145C4.64247 16.677 4.95543 16.9761 5.32759 17.1836C5.69974 17.3911 6.11875 17.5 6.54484 17.5H12.4998H14.9998M21.2486 5L21.2498 16.25L17.0098 22.61C16.5136 23.3537 16.2498 24.2263 16.2498 25.12C16.2498 25.7438 15.7436 26.25 15.1186 26.25H14.9986C14.3355 26.25 13.6997 25.9866 13.2308 25.5178C12.762 25.0489 12.4986 24.413 12.4986 23.75V17.5M21.2486 5H23.7498C24.4129 5 25.0488 5.26339 25.5176 5.73223C25.9864 6.20107 26.2498 6.83696 26.2498 7.5V15C26.2498 15.663 25.9864 16.2989 25.5176 16.7678C25.0488 17.2366 24.4129 17.5 23.7498 17.5H20.6248",
    stroke: "#9A9B9E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDownIcon);
export default __webpack_public_path__ + "static/media/ThumbDownIcon.49572426693a61d8a6ccf7fd7031fdd0.svg";
export { ForwardRef as ReactComponent };